import { FormControl } from '@angular/forms'

export type ToggleState = boolean | null

export interface ClientIPModalSettings {
  showArchivedPrograms: ToggleState
  showTerminatedProgramsEnrollments: ToggleState
  showArchivedSubprograms: ToggleState
  showTerminatedSubprogramsEnrollments: ToggleState
  showClosedIP: ToggleState
  showCompletedGoals: ToggleState
  showCompletedSteps: ToggleState
  dueDate: Date
}

export interface ClientIPOutsideSettings {
  search: string
}

export interface ClientIPSettings extends ClientIPModalSettings, ClientIPOutsideSettings {}

export interface ClientIPModalSettingsForm {
  showArchivedPrograms: FormControl<ToggleState>
  showTerminatedProgramsEnrollments: FormControl<ToggleState>
  showArchivedSubprograms: FormControl<ToggleState>
  showTerminatedSubprogramsEnrollments: FormControl<ToggleState>
  showClosedIP: FormControl<ToggleState>
  showCompletedGoals: FormControl<ToggleState>
  showCompletedSteps: FormControl<ToggleState>
  dueDate: FormControl<Date>
}

export enum ClientIPSettingResultType {
  'SUCCESS',
  'SETTING_FAILED',
}

export enum ClientIPSetting {
  SEARCH = 'search',
  SHOW_ARCHIVED_PROGRAMS = 'showArchivedPrograms',
  SHOW_TERMINATED_PROGRAMS_ENROLLMENTS = 'showTerminatedProgramsEnrollments',
  SHOW_ARCHIVED_SUBPROGRAMS = 'showArchivedSubprograms',
  SHOW_TERMINATED_SUBPROGRAMS_ENROLLMENTS = 'showTerminatedSubprogramsEnrollments',
  SHOW_CLOSED_IP = 'showClosedIP',
  SHOW_COMPLETED_GOALS = 'showCompletedGoals',
  SHOW_COMPLETED_STEPS = 'showCompletedSteps',
  DUE_DATE = 'dueDate',
}

export type ClientIPSettingResult =
  | { type: ClientIPSettingResultType.SUCCESS }
  | { type: ClientIPSettingResultType.SETTING_FAILED; setting: ClientIPSetting }
